import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://cgofmuoiwehejhhoxztm.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNnb2ZtdW9pd2VoZWpoaG94enRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyODEwMDksImV4cCI6MjA4OTg1NzAwOX0.-9vNiYnasJTzQKwNDuSf3vBaHmToEwIKSG4Zpv2h3BQ'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
